import React, { useEffect, useState } from "react";
import "./RecentSearches.scss";
import { Button, Form, Modal, Spin, message } from "antd";
import { FormMultiSelectTags } from "../FormInputs/FormSelect";
import { deleteApi, getApi, postApi } from "../../utils/apiServices";
import {
  ADD_RECENT_SEARCH,
  DELETE_RECENT_SEARCH,
  GET_RECENT_SEARCHES,
} from "../../utils/apiPath";
import { CloseOutlined } from "@ant-design/icons";
import { recentSearches, spinContent } from "../../services/customData";
import ToastHelper from "../../services/ToastHelper";

const RecentSearches = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [recentSearchesList, setRecentSearchesList] = useState([]);
  const [filteredSearchesList, setFilteredSearchesList] = useState([]);
  const [open, setOpen] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      const payload = { searchStrings: values?.searches };
      const res = await postApi(`${ADD_RECENT_SEARCH}`, payload);
      setLoading(false);
      message.success("Recent searches added successfully");
      form.resetFields();
      setIsModalOpen(false);
      getRecentSearchesList();
    } catch (error) {
      console.error("Validation Error:", error);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  useEffect(() => {
    getRecentSearchesList();
  }, []);

  const getRecentSearchesList = async () => {
    setLoading(true);
    try {
      const res = await getApi(`${GET_RECENT_SEARCHES}`);
      setRecentSearchesList(res?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching topic items", error);
    }
  };

  useEffect(() => {
    if (recentSearches && recentSearchesList) {
      const filteredSearches = recentSearches.filter(
        (item) =>
          !recentSearchesList.some(
            (val) => val.searchString.toLowerCase() === item.value.toLowerCase()
          )
      );
      setFilteredSearchesList(filteredSearches);
    } else {
      setFilteredSearchesList(recentSearches);
    }
  }, [recentSearches, recentSearchesList]);

  const handleDeleteModal = (item) => {
    setDeleteItem(item);
    setOpen(true);
  };

  const handleClose = () => {
    setDeleteItem(null);
    setOpen(false);
  };

  const handleDeleteProduct = async () => {
    try {
      const res = await deleteApi(
        `${DELETE_RECENT_SEARCH}?recentSearchId=${deleteItem?.recentSearchId}`
      );

      if (res?.statusCode === 200) {
        ToastHelper.success("Recent search deleted successfully");
        handleClose();
        getRecentSearchesList();
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="r-searches">
      <div className="r-searches_container">
        <div className="r-searches_header">
          <div className="r-searches_header_left">
            <h2>Recent Searches</h2>
          </div>
          <div className="r-searches_header_right">
            <Button type="primary" onClick={showModal}>
              Add
            </Button>
          </div>
        </div>
        <div className="r-searches_sections">
          <div className="r-searches_cards">
            {recentSearchesList?.length > 0 &&
              recentSearchesList?.map((topic, index) => {
                return (
                  <div key={index} className="r-searches_card">
                    <div className="r-searches_card_image">
                      <div
                        className="r-searches_card_close"
                        onClick={() => handleDeleteModal(topic)}
                      >
                        <CloseOutlined />
                      </div>
                    </div>
                    <div className="r-searches_card_content">
                      <h3>{topic?.searchString}</h3>
                    </div>
                  </div>
                );
              })}
          </div>
          {loading ? (
            <div className="r-searches_loading">
              <Spin tip="Loading">{spinContent}</Spin>
            </div>
          ) : (
            filteredSearchesList?.length === 0 && (
              <h5>No recent searches available</h5>
            )
          )}
        </div>
      </div>
      <Modal
        title="Add"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        centered={true}
        maskClosable={false}
      >
        <div className="t-product_modal">
          <Form form={form} layout="vertical">
            <FormMultiSelectTags
              label="Select or Add recent searches"
              name="searches"
              placeholder="Select or add recent searches"
              rules={[{ required: true }]}
              options={filteredSearchesList}
              mode="tags"
            />
          </Form>
        </div>
      </Modal>
      <Modal
        title="Confirm"
        open={open}
        onOk={handleDeleteProduct}
        onCancel={handleClose}
        width={300}
      >
        <p>Are you sure want to delete?</p>
      </Modal>
    </div>
  );
};

export default RecentSearches;
